import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DisabledContext = /*#__PURE__*/createContext(false);
function Disableable({
  disabled = false,
  open,
  toolbarTooltip,
  children
}) {
  return /*#__PURE__*/_jsx(DisabledContext.Provider, {
    value: disabled,
    children: /*#__PURE__*/_jsx(Tooltip, {
      disabled: !disabled || !toolbarTooltip,
      open: open,
      placement: "bottom",
      title: toolbarTooltip,
      children: children
    })
  });
}
export default Disableable;